import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleInfo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubbleInfo"><Path d="M3.5 3.5L20.5 3.50002V18.5H15.0155L11.9979 21L9.0155 18.5L3.5 18.5V3.5Z" stroke="currentColor"/><Path d="M12 14.5V10" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 8H12.5V7H11.5V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleInfo;
